export const getSingleInwardEntryData = async (dataHouse, stockEntryId) => {

    const singleStockEntry = await dataHouse.find((data) => {
        return data.id === stockEntryId;
    });
    return singleStockEntry;
};
